export default "__VITE_ASSET__ee72f456__"